import type { IDisableReasonEntry } from '../types';

import { genTextByTotal, getLabelByTemplateType } from '~/utils';
import { TemplateType } from '~/types/template';
import { IDisableReasonKey } from '../types';

// Define the disable reasons as an array with specific types
export const DATA_TEMPLATE_DISABLED: IDisableReasonEntry[] = [
  {
    key: IDisableReasonKey.IS_USED_FOR_CONTROL,
    content: () => 'This template is used for Control version',
  },
  {
    key: IDisableReasonKey.IS_USED_FOR_VARIANT,
    content: () => 'This template is used for Variant version',
  },
  {
    key: IDisableReasonKey.IS_SELECTED,
    content: () => 'This template is selected',
  },
  {
    key: IDisableReasonKey.IS_NO_ASSIGNED_BY_GEMPAGES,
    hidePageAssigned: true,
    content: ({ templateType }) => {
      if (templateType === TemplateType.HOME) {
        return 'Make this template as default to use it';
      }

      return `Template needs at least one ${getLabelByTemplateType(templateType)} assigned to work`;
    },
    isHasShortcut: true,
  },
  {
    key: IDisableReasonKey.IS_NO_ASSIGNED_BY_SHOPIFY,
    hidePageAssigned: true,
    content: ({ templateType }) => {
      if (templateType === TemplateType.HOME) {
        return 'Make this template as default to use it';
      }

      return `Template needs at least one ${getLabelByTemplateType(templateType)} assigned to work`;
    },
    isHasShortcut: true,
  },
  {
    key: IDisableReasonKey.IS_TEMPLATE_DRAFT,
    content: () => 'Template needs to be published to work',
  },
  {
    key: IDisableReasonKey.IS_TEMPLATE_USED_TO_TEST,
    content: ({ assignedCount, assignedTotal, templateType }) => {
      const pluralizedType = genTextByTotal(templateType, assignedTotal);
      return `This template is used to test for ${assignedCount}/${assignedTotal} ${pluralizedType}`;
    },
  },
  {
    key: IDisableReasonKey.IS_USED_FOR_OTHER_CAMPAIGN,
    content: () => 'This template is used in another experiment',
    isHasShortcut: true,
  },
  {
    key: IDisableReasonKey.IS_USED_FOR_OTHER_CAMPAIGN_GROUP,
    content: () => 'This template is used in another experiment',
    isHasShortcut: true,
  },
  {
    key: IDisableReasonKey.IS_TEMPLATE_VARIANT_NOT_ASSIGNED,
    content: () => 'This template is not same page type with Variant',
  },
];
